// extracted by mini-css-extract-plugin
module.exports = {"theComp":"MemberB_theComp__vKqE2"};